<button
  type="button"
  class="ph-product-screenshot ph-product-screenshot--zoomable"
  (click)="open()"
  [attr.aria-label]="'PRODUCTS.SCREENSHOT_ZOOM' | translate">
  <img
    [src]="src"
    [alt]="altKey | translate"
    loading="lazy"
    (error)="onError($event)">
  <span class="ph-product-screenshot__zoom-hint" aria-hidden="true">
    <i class="lni lni-zoom-in"></i>
    {{ 'PRODUCTS.SCREENSHOT_ZOOM' | translate }}
  </span>
</button>

<div
  *ngIf="isOpen"
  class="ph-screenshot-lightbox"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="currentSlide.altKey | translate"
  (click)="close()">
  <div class="ph-screenshot-lightbox__panel" (click)="$event.stopPropagation()">
    <button
      type="button"
      class="ph-screenshot-lightbox__close"
      (click)="close()"
      [attr.aria-label]="'PRODUCTS.SCREENSHOT_CLOSE' | translate">
      <i class="lni lni-close" aria-hidden="true"></i>
    </button>

    <button
      *ngIf="hasPrev"
      type="button"
      class="ph-screenshot-lightbox__nav ph-screenshot-lightbox__nav--prev"
      (click)="prev()"
      [attr.aria-label]="'PRODUCTS.SCREENSHOT_PREV' | translate">
      <i class="lni lni-chevron-left" aria-hidden="true"></i>
    </button>

    <figure class="ph-screenshot-lightbox__figure">
      <img
        class="ph-screenshot-lightbox__img"
        [src]="currentSlide.src"
        [alt]="currentSlide.altKey | translate"
        (error)="onError($event)">
      <figcaption class="ph-screenshot-lightbox__caption">{{ currentSlide.altKey | translate }}</figcaption>
    </figure>

    <button
      *ngIf="hasNext"
      type="button"
      class="ph-screenshot-lightbox__nav ph-screenshot-lightbox__nav--next"
      (click)="next()"
      [attr.aria-label]="'PRODUCTS.SCREENSHOT_NEXT' | translate">
      <i class="lni lni-chevron-right" aria-hidden="true"></i>
    </button>
  </div>
</div>
